// Constants for your Cognito setup
import { OtpLogin } from 'components/Login/OtpLogin'
import { SignUp } from 'components/Login/SignUp'
import { useIntake } from 'hooks/useIntakeContext'
import { useEffect } from 'react'

let localRedirectionURL = window.location.search.startsWith(
  '?redirect_to=' +
    window.location.origin +
    '/onboarding-full?onboardingStep=pickYourPath'
)
  ? '?redirect_to=' +
    window.location.origin +
    '/onboarding-full?onboardingStep=pickYourPath'
  : '?redirect_to=' + window.location.origin + '/dashboard'

// env file
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN
export const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID
export const POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID
// Replace with your app's redirect URI - TODO we need to match
// add a callback URL to the google/facebook signin stuff in amplify studio
// or I can try to do it in cdk separately, but it might break things
// export const REDIRECT_URI = 'http://localhost:3000/callback'
export const REDIRECT_URI =
  window.location.origin + '/callback' + localRedirectionURL
// console.log(REDIRECT_URI)
export const GOOGLE_PROVIDER = 'Google' // Identity provider (Google)

// Function to trigger Google SSO login through Cognito
const triggerGoogleLogin = () => {
  const authorizationUrl =
    `https://${COGNITO_DOMAIN}/oauth2/authorize?` +
    `response_type=code` +
    `&client_id=${CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&identity_provider=${GOOGLE_PROVIDER}` +
    `&scope=email+openid+profile+aws.cognito.signin.user.admin`

  // Redirect the user to Cognito's authorization endpoint (which redirects to Google)
  // console.log(authorizationUrl)
  window.location.href = authorizationUrl
}

export const OauthLogin = () => {
  return (
    <>
      <div>
        <h3 style={{ margin: 0 }}>Sign in flows</h3>
        <div style={{ border: '1px solid #efefef', marginBottom: '10px' }}>
          <div>
            Oauth Login
            <div>
              <button onClick={triggerGoogleLogin}>Login With Google</button>
            </div>
          </div>
          <div>
            Passwordless Login
            <OtpLogin />
          </div>
        </div>
        <h3 style={{ margin: 0 }}>Sign up flows</h3>
        <div style={{ border: '1px solid #efefef' }}>
          <div>
            Oauth Signup
            <div>
              <button onClick={triggerGoogleLogin}>Sign Up With Google</button>
            </div>
          </div>
          <div>
            Passwordless SignUp
            <SignUp />
          </div>
        </div>
      </div>
    </>
  )
}
